module.exports = __webpack_public_path__ + "static/media/casino-jackpot-games.b7f41064.png";